export default __webpack_public_path__ + "static/media/inactive_smile.351de37a.svg";